const TONES = {
  brunswick: "bg-brand-brunswick",
  licorice: "bg-brand-licorice",
  sepia: "bg-brand-sepia",
  champagne: "bg-brand-champagne",
  moss: "bg-brand-moss",
};

export const Photo = ({ src, alt, label, tone = "brunswick", className = "", imgClassName = "", eager = false, testId }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        data-testid={testId}
        loading={eager ? "eager" : "lazy"}
        fetchpriority={eager ? "high" : undefined}
        className={`h-full w-full object-cover ${imgClassName}`}
      />
    );
  }
  const dark = tone !== "champagne";
  return (
    <div data-testid={testId} role="img" aria-label={alt} className={`grain relative h-full w-full overflow-hidden ${TONES[tone]} ${className}`}>
      <img
        src={dark ? "/images/dune-villas-white.png" : "/images/dune-villa-black.png"}
        alt=""
        aria-hidden="true"
        className="absolute left-1/2 top-1/2 w-2/5 max-w-[220px] -translate-x-1/2 -translate-y-1/2 opacity-[0.14]"
      />
      {label && (
        <span className={`absolute bottom-4 left-5 z-[2] font-serif text-sm italic ${dark ? "text-brand-ivory/70" : "text-brand-licorice/60"}`}>
          {label}
        </span>
      )}
    </div>
  );
};
